// © 2013 - 2024 Tinder, Inc., ALL RIGHTS RESERVED

import React, { memo } from 'react';
import { IconProps as Props } from '../types';

const SvgInfoOutline: React.FC<Props> = (allProps) => {
  const { fill, primary, secondary, tertiary, quaternary, title, ...props } = allProps;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      focusable="false"
      role="img"
      {...props}
    >
      <title>{title}</title>
      <g fill={primary ?? fill ?? 'currentColor'}>
        <path d="M12 0C5.376 0 0 5.376 0 12s5.376 12 12 12 12-5.376 12-12S18.624 0 12 0m0 22C6.708 22 2 17.292 2 12S6.708 2 12 2s10 4.708 10 10-4.708 10-10 10" />
        <path d="M10.615 10.356h2.77v7.384h-2.77z" />
        <path
          fillRule="evenodd"
          d="M12 9.23A1.615 1.615 0 1 0 12 6a1.615 1.615 0 0 0 0 3.23"
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
};

const Memo = memo(SvgInfoOutline);
export default Memo;
